export const ONBOARDING_SEEN_KEY = 'sekretly_onboarding_seen';

/** True once the pre-auth onboarding carousel has been shown and exited
 *  through any path (Google, local account, or skip). */
export function hasSeenOnboarding(): boolean {
  try {
    return !!localStorage.getItem(ONBOARDING_SEEN_KEY);
  } catch {
    return false;
  }
}

export function markOnboardingSeen() {
  try { localStorage.setItem(ONBOARDING_SEEN_KEY, '1'); } catch { /* ignore */ }
}
